import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/latestContractsActions';
import initialState from '../../reducers/initialState';
import HomePageTable from './HomePageTable';
import HOME_PAGE from '../../constants/homePage';
import { preprocessTableEntries } from "../../lib/homepageUtils";

export class LatestContracts extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      latestContractsQuery: initialState.latestContractsQuery,
    };
    this.sendQuery();
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedPartner &&
        this.props.selectedPartner !== prevProps.selectedPartner)
    {
      this.sendQuery(this.props.selectedPartner);
    }
  }

  sendQuery(partner = this.props.selectedPartner, page = 1) {
    const query = this.state.latestContractsQuery;
    this.props.actions.fetchLatestContracts(
      {
        start_date: query.startDate.format('YYYY-MM-DD'),
        end_date: query.endDate.format('YYYY-MM-DD'),
        new_or_renewal: query.newOrRenewal,
        stage_name: query.stageName,
        q: query.searchParam,
        sort: query.sort,
        order: query.order,
        page: page,
        hits_per_page: 15,
        ...partner
      }
    );
  }

  render() {
    const contracts = preprocessTableEntries(this.props.latestContracts, 'date_received');

    return (
      <HomePageTable
        dataType="pipeline"
        content={contracts}
        contentError={this.props.latestContractsError}
        title="Contracts Out"
        noDataMessage="You have no current contracts out."
        moreInfoMessage={HOME_PAGE.pipelineMoreInfoMessage}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    latestContracts: state.latestContracts,
    latestContractsError: state.latestContractsError,
    selectedPartner: state.partner.selected
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

LatestContracts.propTypes = {
  latestContracts: PropTypes.array.isRequired,
  latestContractsError: PropTypes.bool.isRequired,
  selectedPartner: PropTypes.object,
  actions: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(LatestContracts);
